import { Currencies } from '@/entities/curency'
import { PaymentRequisiteToType } from '@/entities/paymentRequisit'

export enum TopupStatus {
  WaitingPayment = 1,
  ConfirmedByPayer = 2,
  Paid = 11,
  Cancelled = 12,
  Timeout = 13,
  OverPaid = 14,
  PartiallyPaid = 15,
  Returned = 16,
  Disput = 21,
  WaitingPaymentChannel = 31, //Платеж был создан без указания платежного канала и ожидает данные о платежном канале. Платеж в этом статусе невозможно оплатить.
  RollingBack = 32,
  Unknown = 1000,
}
export enum TopupTraderStatus {
  // Все статусы
  All = 1,
  // В ожидании WaitingPayment, ConfirmedByPayer, WaitingPaymentChannel
  WaitingPayment = 2,
  // Завершенные: Paid, OverPaid, PartiallyPaid
  Paid = 3,
  // Отмененные: Cancelled, Timeout, Returned
  Cancelled = 4,
  // Споры: Disput
  Disput = 5,
}
export type TopupsModel = {
  id: string
  status: TopupStatus
  currencyFrom: Currencies
  amountFrom: number
  currencyTo: Currencies
  factAmountFrom?: number
  factAmountTo?: number
  amountTo: number
  createdAt: string
  confirmedAt: string
  exchangeRate: number
  profit: number
  paymentRequisitToValue: string
  paymentRequisitToType: PaymentRequisiteToType
}

//Merchant

export type TopupsModelMerchant = {
  id: string
  payerId: string
  merchantTopupId: string
  status: TopupStatus
  currencyFrom: Currencies
  amountFrom: number
  factAmountFrom: number
  currencyTo: Currencies
  amountTo: number
  factAmountTo: number
  commission: number
  fullName: string
  paymentPageUrl: string
  createdAt: string
  confirmedAt: string
  validTill: string
  exchangeRate: number
  paymentRequisitToValue: string
  paymentRequisitToType: PaymentRequisiteToType
  topupSuccessUrl: string
  topupFailUrl: string
  callbackUrl: string
}
